export default {
  salutation: [{ rule: 'requiredArray' }],
  firstName: [{ rule: 'required' }],
  lastName: [{ rule: 'required' }],
  email: [{ rule: 'required' }, { rule: 'email' }],
  zipCode: [{ rule: 'required' }],
  city: [{ rule: 'required' }]
};
